/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Starred_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Record starred successfully" |
*
* @param {Explorer_Info_Starred_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_starred_success_toast = /** @type {((inputs?: Explorer_Info_Starred_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Starred_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement ajoute aux favoris")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Aufnahme startete erfolgreich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Record contrassegnato con una stella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись успешно завершена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El registro se ha marcado con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("唱片公司成功出品")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードのスターが正常に作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड ने सफलतापूर्वक अभिनय किया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Record estrelou com sucesso")
	return /** @type {LocalizedString} */ ("Record starred successfully")
});